export default __webpack_public_path__ + "static/media/announcement_4@3x.462f8b88.png";